import styled from 'styled-components';

export const SaveSearchButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
`;
